import http from "./http";

class RolesService {
    index(token){
        return http.get("/api/roles/index",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    index_roles(){
        return http.get("/api/roles");
    }

    store(data,token){
        return http.post("/api/roles/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/roles/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/roles/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/roles/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/roles/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new RolesService()